<script>
export default {
  name: 'IconStar',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.08325 4.26659L6.94992 1.84992C7.08325 1.67214 7.24158 1.54159 7.42492 1.45825C7.60825 1.37492 7.79992 1.33325 7.99992 1.33325C8.19992 1.33325 8.39158 1.37492 8.57492 1.45825C8.75825 1.54159 8.91658 1.67214 9.04992 1.84992L10.9166 4.26659L13.7499 5.21659C14.0388 5.30547 14.2666 5.46936 14.4333 5.70825C14.5999 5.94714 14.6833 6.21103 14.6833 6.49992C14.6833 6.63325 14.6638 6.76659 14.6249 6.89992C14.586 7.03325 14.5221 7.16103 14.4333 7.28325L12.5999 9.88325L12.6666 12.6166C12.6777 13.0055 12.5499 13.3333 12.2833 13.5999C12.0166 13.8666 11.7055 13.9999 11.3499 13.9999C11.3277 13.9999 11.2055 13.9833 10.9833 13.9499L7.99992 13.1166L5.01659 13.9499C4.96103 13.9721 4.89992 13.986 4.83325 13.9916C4.76659 13.9971 4.70547 13.9999 4.64992 13.9999C4.29436 13.9999 3.98325 13.8666 3.71659 13.5999C3.44992 13.3333 3.32214 13.0055 3.33325 12.6166L3.39992 9.86659L1.58325 7.28325C1.49436 7.16103 1.43047 7.03325 1.39159 6.89992C1.3527 6.76659 1.33325 6.63325 1.33325 6.49992C1.33325 6.22214 1.41381 5.96381 1.57492 5.72492C1.73603 5.48603 1.96103 5.31659 2.24992 5.21659L5.08325 4.26659Z"
      :fill="color"
    />
  </svg>
</template>
